import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CGU() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('cgu');

  const tabs = [
    { key: 'cgu', label: '📋 CGU' },
    { key: 'charte', label: '🔒 Charte' },
    { key: 'confidentialite', label: '🛡️ Confidentialité' },
    { key: 'animateurs', label: '🎯 Animateurs' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7', paddingBottom: 80 }}>

      <div style={{ background: 'linear-gradient(135deg, #1C2B1E, #2D7A52)', padding: '48px 24px 24px' }}>
        <button onClick={() => navigate(-1)} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 100, padding: '8px 16px', color: 'white', fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer', marginBottom: 16 }}>← Retour</button>
        <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.5rem', color: 'white', marginBottom: 4 }}>
          <span style={{ color: '#52C289' }}>Woo</span><span style={{ color: '#FF7043' }}>ki</span> — Documents légaux
        </div>
        <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.6)' }}>Dernière mise à jour : Mai 2026</div>
      </div>

      <div style={{ display: 'flex', gap: 0, overflowX: 'auto', scrollbarWidth: 'none', background: 'white', borderBottom: '1px solid #EEF2EE' }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setActiveTab(t.key)} style={{ flexShrink: 0, padding: '14px 16px', border: 'none', background: 'transparent', fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.78rem', color: activeTab === t.key ? '#3D9A6A' : '#8A9E8D', borderBottom: activeTab === t.key ? '3px solid #3D9A6A' : '3px solid transparent', cursor: 'pointer' }}>
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ padding: '24px 20px', maxWidth: 600, margin: '0 auto' }}>

        {/* CGU */}
        {activeTab === 'cgu' && (
          <div>
            <h2 style={{ fontFamily: 'Fredoka One, cursive', color: '#1C2B1E', fontSize: '1.2rem', marginBottom: 20 }}>Conditions Générales d'Utilisation</h2>

            {[
              {
                titre: '1. Présentation de Wooki',
                contenu: `Wooki est une plateforme numérique de mise en relation entre familles souhaitant organiser ou participer à des activités de loisirs en plein air, et entre familles et animateurs indépendants proposant des activités encadrées.

Wooki est édité par la société Wooki, dont le siège social est en France. Wooki n'est pas un prestataire de services d'animation. Wooki est exclusivement une plateforme technologique de mise en relation.`
              },
              {
                titre: '2. Acceptation des CGU',
                contenu: `L'utilisation de la plateforme Wooki implique l'acceptation pleine et entière des présentes Conditions Générales d'Utilisation. Si vous n'acceptez pas ces conditions, vous devez cesser d'utiliser la plateforme.

Ces CGU sont opposables à tout utilisateur dès son inscription sur la plateforme.`
              },
              {
                titre: '3. Description du service',
                contenu: `Wooki propose les services suivants :
— Consultation d'activités publiées par des utilisateurs ou des animateurs indépendants
— Inscription à des activités et mise en relation avec l'organisateur
— Création et publication d'activités
— Inscription en tant qu'animateur indépendant pour proposer des activités payantes
— Messagerie entre participants d'une même activité

Wooki se réserve le droit de modifier, suspendre ou interrompre tout ou partie du service à tout moment sans préavis.`
              },
              {
                titre: '4. Responsabilité de Wooki — Limitation express',
                contenu: `WOOKI EST UNE PLATEFORME DE MISE EN RELATION. À CE TITRE :

— Wooki n'organise pas les activités publiées par les utilisateurs
— Wooki n'emploie pas les animateurs indépendants inscrits sur la plateforme
— Wooki ne garantit pas la qualité, la sécurité ou l'exécution des activités
— Wooki ne vérifie pas l'authenticité des diplômes, certifications ou assurances fournis par les animateurs
— Wooki n'est pas partie au contrat conclu entre un parent et un animateur indépendant
— Wooki ne peut être tenu responsable d'aucun dommage corporel, matériel ou moral survenu lors d'une activité organisée via la plateforme

La responsabilité de Wooki ne saurait être engagée en cas d'accident, blessure, décès, vol, dommage matériel ou tout autre préjudice survenu avant, pendant ou après une activité organisée ou proposée via la plateforme.

Wooki ne pourra être tenu responsable des agissements des utilisateurs, qu'ils soient organisateurs, animateurs ou participants.`
              },
              {
                titre: '5. Responsabilité des organisateurs et animateurs',
                contenu: `Toute personne organisant une activité via Wooki, qu'elle soit utilisateur particulier ou animateur indépendant, est seule et entièrement responsable :

— De la sécurité des participants pendant l'activité
— Du respect de la réglementation applicable à son activité (diplômes, assurances, déclarations)
— Des dommages pouvant survenir lors de l'activité
— De l'exactitude des informations publiées sur la plateforme
— Du respect des droits des tiers

Les animateurs indépendants reconnaissent exercer leur activité en toute indépendance, sans lien de subordination avec Wooki. Ils sont seuls responsables de leur statut juridique, de leurs déclarations fiscales et sociales, et de leur couverture assurantielle.`
              },
              {
                titre: '6. Responsabilité des parents participants',
                contenu: `Les parents ou représentants légaux participant à une activité via Wooki reconnaissent :

— Être présents et responsables de leurs enfants pendant toute la durée de l'activité
— Avoir évalué par eux-mêmes le sérieux et la compétence de l'organisateur ou animateur
— Avoir pris connaissance des règles de l'activité avant d'y inscrire leurs enfants
— Ne pas pouvoir se retourner contre Wooki en cas d'incident lors de l'activité

La présence des parents est obligatoire pendant toute activité Wooki. Wooki ne peut être tenu responsable si cette règle n'est pas respectée.`
              },
              {
                titre: '7. Paiements et transactions',
                contenu: `Pour les activités gratuites : aucune transaction financière ne transite par Wooki.

Pour les activités payantes proposées par des animateurs indépendants : le paiement s'effectue directement entre le parent et l'animateur, hors de la plateforme Wooki. Wooki n'est pas partie à cette transaction et ne peut être tenu responsable de tout litige financier entre un parent et un animateur.

Wooki se réserve le droit d'introduire un système de paiement en ligne dans le futur. Les conditions applicables seront alors précisées dans une mise à jour des présentes CGU.`
              },
              {
                titre: '8. Contenu publié par les utilisateurs',
                contenu: `Les utilisateurs sont seuls responsables des contenus qu'ils publient sur la plateforme (descriptions d'activités, messages, photos, informations de profil).

Wooki se réserve le droit de supprimer tout contenu contraire aux présentes CGU, aux lois en vigueur, ou portant atteinte aux droits de tiers, sans préavis ni justification.

Sont notamment interdits : les contenus à caractère sexuel, violent, haineux, discriminatoire, ou portant atteinte à la dignité humaine. Les contenus comportant des coordonnées personnelles (numéro de téléphone, adresse, réseaux sociaux) sont également interdits dans les espaces de messagerie.`
              },
              {
                titre: '9. Suspension et résiliation',
                contenu: `Wooki se réserve le droit de suspendre ou résilier l'accès d'un utilisateur à la plateforme en cas de manquement aux présentes CGU, sans préavis ni indemnité.

L'utilisateur peut supprimer son compte à tout moment en contactant Wooki à l'adresse contact@wooki.app.`
              },
              {
                titre: '10. Droit applicable et juridiction',
                contenu: `Les présentes CGU sont régies par le droit français. En cas de litige, les parties s'engagent à rechercher une solution amiable avant tout recours judiciaire. À défaut d'accord amiable, les tribunaux français seront seuls compétents.`
              },
            ].map((s, i) => (
              <div key={i} style={{ marginBottom: 24 }}>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.95rem', color: '#1C2B1E', marginBottom: 8 }}>{s.titre}</div>
                <div style={{ fontSize: '0.82rem', color: '#4A6355', lineHeight: 1.8, whiteSpace: 'pre-line', background: 'white', borderRadius: 16, padding: '14px 16px', boxShadow: '0 2px 8px rgba(28,43,30,0.06)' }}>{s.contenu}</div>
              </div>
            ))}
          </div>
        )}

        {/* CHARTE */}
        {activeTab === 'charte' && (
          <div>
            <h2 style={{ fontFamily: 'Fredoka One, cursive', color: '#1C2B1E', fontSize: '1.2rem', marginBottom: 20 }}>Charte de Sécurité Wooki</h2>

            <div style={{ background: 'linear-gradient(135deg, #EDF7F1, #D4EEE0)', borderRadius: 20, padding: '16px 18px', marginBottom: 20 }}>
              <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.95rem', color: '#1C2B1E', marginBottom: 8 }}>🌿 Notre engagement</div>
              <div style={{ fontSize: '0.82rem', color: '#4A6355', lineHeight: 1.7 }}>
                Wooki place la sécurité des enfants au cœur de ses priorités. Cette charte définit les règles que tous les utilisateurs s'engagent à respecter en utilisant la plateforme.
              </div>
            </div>

            {[
              {
                titre: '🔒 Règle n°1 — Présence parentale obligatoire',
                contenu: `La présence d'un parent ou représentant légal est OBLIGATOIRE pendant toute la durée d'une activité Wooki, qu'elle soit gratuite ou payante, organisée par un particulier ou un animateur professionnel.

Aucune activité Wooki ne peut impliquer la garde d'enfants en l'absence de leurs parents. Wooki n'est en aucun cas un service de garde d'enfants.

Tout organisateur ou animateur qui accepterait des enfants non accompagnés de leurs parents engage sa seule responsabilité et viole la présente charte.`
              },
              {
                titre: '📍 Règle n°2 — Lieux publics uniquement',
                contenu: `Toutes les activités Wooki doivent se dérouler dans des lieux publics accessibles à tous : parcs, terrains de sport municipaux, espaces verts, voies piétonnes...

Les activités dans des lieux privés (domicile particulier, propriété privée sans accès public) sont strictement interdites sauf accord explicite de tous les participants et information préalable sur la plateforme.`
              },
              {
                titre: '🚫 Règle n°3 — Zéro échange de coordonnées privées',
                contenu: `Il est strictement interdit d'échanger des coordonnées personnelles dans les espaces de messagerie Wooki (numéros de téléphone personnels, adresses postales, profils sur les réseaux sociaux, adresses email personnelles).

Les échanges doivent se limiter à la coordination de l'activité. Tout contenu contrevenant à cette règle sera supprimé automatiquement par notre système de modération.`
              },
              {
                titre: '👶 Règle n°4 — Respect de l\'âge recommandé',
                contenu: `Chaque activité précise une tranche d'âge recommandée. Les organisateurs sont responsables de l'adéquation de leur activité avec l'âge des participants.

Les parents s'assurent que l'activité est adaptée à l'âge et aux capacités de leurs enfants avant de s'inscrire.`
              },
              {
                titre: '🤝 Règle n°5 — Respect et bienveillance',
                contenu: `Tous les participants — parents, enfants, organisateurs et animateurs — s'engagent à se traiter avec respect et bienveillance.

Tout comportement discriminatoire, violent, harcelant ou irrespectueux entraîne l'exclusion immédiate de la plateforme.`
              },
              {
                titre: '🚨 Signalement',
                contenu: `Tout comportement suspect ou contraire à cette charte doit être signalé immédiatement à l'équipe Wooki via le bouton de signalement dans l'application ou par email à contact@wooki.app.

En cas de danger immédiat, appelez le 15 (SAMU), le 17 (Police) ou le 18 (Pompiers).`
              },
            ].map((s, i) => (
              <div key={i} style={{ marginBottom: 20 }}>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.95rem', color: '#1C2B1E', marginBottom: 8 }}>{s.titre}</div>
                <div style={{ fontSize: '0.82rem', color: '#4A6355', lineHeight: 1.8, whiteSpace: 'pre-line', background: 'white', borderRadius: 16, padding: '14px 16px', boxShadow: '0 2px 8px rgba(28,43,30,0.06)' }}>{s.contenu}</div>
              </div>
            ))}
          </div>
        )}

        {/* CONFIDENTIALITÉ */}
        {activeTab === 'confidentialite' && (
          <div>
            <h2 style={{ fontFamily: 'Fredoka One, cursive', color: '#1C2B1E', fontSize: '1.2rem', marginBottom: 20 }}>Politique de Confidentialité</h2>

            {[
              {
                titre: '1. Données collectées',
                contenu: `Wooki collecte les données suivantes lors de l'inscription :
— Prénom
— Numéro de téléphone
— Localisation approximative (pour afficher les activités proches)

Pour les animateurs inscrits, des documents peuvent être uploadés volontairement (diplômes, assurances). Ces documents sont stockés de façon sécurisée.

Wooki ne collecte pas de nom de famille, d'adresse postale, de données bancaires, ni d'informations sur les enfants sans le consentement explicite de l'utilisateur.`
              },
              {
                titre: '2. Utilisation des données',
                contenu: `Les données collectées sont utilisées exclusivement pour :
— Permettre la connexion à la plateforme
— Afficher les activités proches de l'utilisateur
— Envoyer des notifications liées aux activités (avec consentement)
— Contacter l'utilisateur en cas de problème lié à son compte

Wooki ne vend pas les données personnelles des utilisateurs à des tiers. Wooki n'utilise pas les données à des fins publicitaires.`
              },
              {
                titre: '3. Durée de conservation',
                contenu: `Les données personnelles sont conservées pendant toute la durée d'activité du compte. En cas de suppression du compte, les données sont effacées dans un délai de 30 jours.

Les messages échangés dans les espaces de chat sont conservés pendant 6 mois puis supprimés automatiquement.`
              },
              {
                titre: '4. Droits des utilisateurs (RGPD)',
                contenu: `Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
— Droit d'accès à vos données
— Droit de rectification
— Droit à l'effacement (droit à l'oubli)
— Droit à la portabilité
— Droit d'opposition

Pour exercer ces droits, contactez-nous à : contact@wooki.app`
              },
              {
                titre: '5. Sécurité',
                contenu: `Wooki utilise Supabase comme base de données sécurisée avec chiffrement des données en transit et au repos. L'accès aux données est strictement limité à l'équipe technique de Wooki.

Aucune donnée sensible n'est stockée en clair.`
              },
            ].map((s, i) => (
              <div key={i} style={{ marginBottom: 20 }}>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.95rem', color: '#1C2B1E', marginBottom: 8 }}>{s.titre}</div>
                <div style={{ fontSize: '0.82rem', color: '#4A6355', lineHeight: 1.8, whiteSpace: 'pre-line', background: 'white', borderRadius: 16, padding: '14px 16px', boxShadow: '0 2px 8px rgba(28,43,30,0.06)' }}>{s.contenu}</div>
              </div>
            ))}
          </div>
        )}

        {/* ANIMATEURS */}
        {activeTab === 'animateurs' && (
          <div>
            <h2 style={{ fontFamily: 'Fredoka One, cursive', color: '#1C2B1E', fontSize: '1.2rem', marginBottom: 20 }}>Conditions Spécifiques aux Animateurs</h2>

            <div style={{ background: '#FFF8E1', borderRadius: 20, padding: '16px 18px', marginBottom: 20, border: '2px solid #FFE082' }}>
              <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.95rem', color: '#FF8F00', marginBottom: 8 }}>⚠️ Important — À lire attentivement</div>
              <div style={{ fontSize: '0.82rem', color: '#8A4000', lineHeight: 1.7 }}>
                En vous inscrivant comme animateur sur Wooki, vous acceptez d'agir en tant que prestataire indépendant et reconnaissez être seul responsable de vos activités.
              </div>
            </div>

            {[
              {
                titre: '1. Statut de prestataire indépendant',
                contenu: `En s'inscrivant comme animateur sur Wooki, la personne reconnaît explicitement :

— Agir en tant que prestataire indépendant, sans aucun lien de subordination avec Wooki
— Wooki n'est pas son employeur et ne peut être assimilé à tel
— Être seul responsable de son statut juridique (auto-entrepreneur, association, société...)
— Être seul responsable de ses déclarations fiscales et sociales
— Wooki ne verse aucune rémunération et ne prélève aucune commission sur les paiements actuellement

L'animateur s'engage à régulariser sa situation juridique si nécessaire avant de proposer des activités payantes.`
              },
              {
                titre: '2. Responsabilité de l\'animateur',
                contenu: `L'animateur est seul et entièrement responsable :

— De la sécurité des participants pendant ses activités
— Du respect de la réglementation applicable à son activité (diplômes BPJEPS, BAFA, ou autres selon l'activité)
— De la souscription d'une assurance Responsabilité Civile Professionnelle adaptée
— De l'exactitude des informations publiées sur son profil et ses activités
— Des dommages corporels, matériels ou moraux pouvant survenir lors de ses activités

Wooki ne peut en aucun cas être tenu co-responsable des dommages survenus lors d'une activité proposée par un animateur.`
              },
              {
                titre: '3. Documents et diplômes',
                contenu: `Les documents uploadés sur la plateforme (diplômes, certifications, assurances) sont fournis par l'animateur sous sa seule responsabilité.

Wooki affiche ces documents à titre informatif uniquement. Wooki ne vérifie pas l'authenticité, la validité ou l'exactitude des documents fournis.

En uploadant un document, l'animateur certifie sur l'honneur que ce document est authentique et en cours de validité. Toute fausse déclaration engage la seule responsabilité de l'animateur.

Wooki se réserve le droit de retirer de la plateforme tout animateur dont les documents s'avèreraient frauduleux.`
              },
              {
                titre: '4. Règles obligatoires pour les activités',
                contenu: `Tout animateur inscrit sur Wooki s'engage à respecter les règles suivantes sans exception :

— Les parents doivent être présents pendant toute la durée de l'activité
— Les activités doivent se dérouler dans des lieux publics
— Le nombre minimum et maximum de participants doit être respecté
— L'âge des participants doit correspondre à la tranche d'âge annoncée
— Aucun échange de coordonnées personnelles dans les espaces de messagerie

Le non-respect de ces règles entraîne la suspension immédiate du compte animateur.`
              },
              {
                titre: '5. Paiements',
                contenu: `Actuellement, les paiements entre parents et animateurs s'effectuent directement entre les parties, hors de la plateforme Wooki.

Wooki n'est pas partie à ces transactions et décline toute responsabilité en cas de litige financier entre un parent et un animateur.

L'animateur s'engage à communiquer clairement ses tarifs sur son profil et à respecter les tarifs annoncés.`
              },
              {
                titre: '6. Suppression de compte',
                contenu: `Wooki se réserve le droit de supprimer ou suspendre le compte d'un animateur sans préavis ni indemnité dans les cas suivants :
— Non-respect des présentes conditions
— Signalement par des utilisateurs
— Fausse déclaration concernant diplômes ou assurances
— Comportement contraire à la charte de sécurité
— Activité jugée inappropriée ou dangereuse par l'équipe Wooki`
              },
            ].map((s, i) => (
              <div key={i} style={{ marginBottom: 20 }}>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.95rem', color: '#1C2B1E', marginBottom: 8 }}>{s.titre}</div>
                <div style={{ fontSize: '0.82rem', color: '#4A6355', lineHeight: 1.8, whiteSpace: 'pre-line', background: 'white', borderRadius: 16, padding: '14px 16px', boxShadow: '0 2px 8px rgba(28,43,30,0.06)' }}>{s.contenu}</div>
              </div>
            ))}

            <div style={{ background: '#EDF7F1', borderRadius: 20, padding: '16px 18px', marginTop: 8 }}>
              <div style={{ fontSize: '0.82rem', color: '#4A6355', lineHeight: 1.7, textAlign: 'center' }}>
                En utilisant Wooki comme animateur, vous acceptez l'intégralité de ces conditions. Pour toute question : <strong>contact@wooki.app</strong>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}